import type { ComputedRef, Ref } from 'vue'

import { useDevicesLiveKit } from '@hooks/classroom/devices-live-kit.hook'
import { useClassroomPermissionsLiveKit } from '@hooks/classroom/permissions-live-kit-app.hook'

interface DeviceOption {
  deviceId: string
  label: string
}

interface ClassroomDevicesReturn {
  cameras: Ref<DeviceOption[]>
  microphones: Ref<DeviceOption[]>
  speakers: Ref<DeviceOption[]>
  selectedCameraId: Ref<string>
  selectedMicId: Ref<string>
  selectedSpeakerId: Ref<string>
  hasPermissions: ComputedRef<boolean>
  loadDevices: () => Promise<void>
  subscribeDevices: () => () => void
  requestPermissions: () => Promise<void>
  selectCamera: (deviceId: string) => Promise<void>
  selectMicrophone: (deviceId: string) => Promise<void>
  selectSpeaker: (deviceId: string) => Promise<void>
}

export const useClassroomDevices = (): ClassroomDevicesReturn => ({
  ...useDevicesLiveKit(),
  ...useClassroomPermissionsLiveKit(),
})
